import JsonLd from "components/seo/JsonLd";
import { ORG_ADDRESS, SITE_NAME, SITE_URL } from "constants/site";

const GlobalJsonLd = () => {
    const organization = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: SITE_NAME,
        legalName: "Lakshmi Narasimha Solutions Pvt Ltd",
        url: SITE_URL,
        logo: `${SITE_URL}/logo512.png`,
        email: "contact@lnsols.com"
    };

    const localBusiness = {
        "@context": "https://schema.org",
        "@type": "ProfessionalService",
        name: `${SITE_NAME} — Web, mobile, cloud & AI`,
        image: `${SITE_URL}/logo512.png`,
        url: SITE_URL,
        telephone: "+91-90323-94343",
        email: "contact@lnsols.com",
        priceRange: "$$",
        address: {
            "@type": "PostalAddress",
            streetAddress: ORG_ADDRESS.streetAddress,
            addressLocality: ORG_ADDRESS.addressLocality,
            addressRegion: ORG_ADDRESS.addressRegion,
            postalCode: ORG_ADDRESS.postalCode,
            addressCountry: ORG_ADDRESS.addressCountry
        },
        areaServed: [
            { "@type": "Country", name: "Canada" },
            { "@type": "Country", name: "United States" },
            { "@type": "Country", name: "India" }
        ],
        openingHoursSpecification: {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday"
            ],
            opens: "09:00",
            closes: "18:00"
        }
    };

    return (
        <>
            <JsonLd data={organization} />
            <JsonLd data={localBusiness} />
        </>
    );
};

export default GlobalJsonLd;
